import { render } from "./OrderResultView.vue?vue&type=template&id=b294ca62&scoped=true&ts=true"
import script from "./OrderResultView.vue?vue&type=script&lang=ts"
export * from "./OrderResultView.vue?vue&type=script&lang=ts"

import "./OrderResultView.vue?vue&type=style&index=0&id=b294ca62&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\KOMEF\\vuejs-heselcare\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b294ca62"]])

export default __exports__